import script from "./LessonPager.vue?vue&type=script&setup=true&lang=ts"
export * from "./LessonPager.vue?vue&type=script&setup=true&lang=ts"

import "./LessonPager.vue?vue&type=style&index=0&id=3b01b2f0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b01b2f0"]])

export default __exports__